import checkboxCheckIcon from '@xero/xui-icon/icons/checkbox-check';
import crossSmallIcon from '@xero/xui-icon/icons/cross-small';
import XUIIcon from '@xero/xui/react/icon';
import { XUIPanel } from '@xero/xui/react/panel';
import { FC } from 'react';

export interface IFeaturesProps {
    featureInfo: IFeatureInfo;
    isSupported: boolean;
}

export interface IFeatureInfo {
    FEATURES: string[];
    HEADING: string;
}

export const FeaturesPanel: FC<IFeaturesProps> = ({ featureInfo, isSupported }) => {
    if (!featureInfo) {
        return <div />;
    }
    const panel = (
        <XUIPanel className='xui-padding-large xui-textcolor-muted xui-column-12-of-12'>
            {featureInfo.FEATURES.map((feature, index) => (
                <div key={index} className='feature-row xui-padding-bottom'>
                    <XUIIcon
                        icon={isSupported ? checkboxCheckIcon : crossSmallIcon}
                        color={isSupported ? 'green' : 'red'}
                        className='xui-margin-right'
                    />
                    {feature}
                </div>
            ))}
        </XUIPanel>
    );

    return (
        <>
            <p className='xui-heading-large'>{featureInfo.HEADING}</p>
            <div className='xui-u-flex'>{panel}</div>
        </>
    );
};
